/**
 * @module structure 批量导入公共全局组件
 * @module svgPlugin SVG批量导入插件
 */
import '../src/styles/index.less'
import { createApp, nextTick } from "vue";
import App from "./App.vue";
import router from "./router";
import Vuex from 'vuex';
import store from "./store";
import bus from './bus';
import 'xe-utils'
import ElementPlus from 'element-plus';
import svgPlugin from "@/assets/svgPlugin";
import { structure } from './components/index'
import 'element-plus/dist/index.css'
// import 'element-plus/lib/theme-chalk/index.css';
import locale from 'element-plus/lib/locale/lang/zh-cn'
import 'vxe-table/lib/style.css'

import VXETable from 'vxe-table'
import VXETablePluginElement from 'vxe-table-plugin-element'
// import '@/styles/element-variables.scss'

// 货币单位处理
import currency from 'currency.js';

// 引入常用less
import './styles/common.less';

const app = createApp(App);


//引入axios
import axios from 'axios';
// import VueAxios from 'vue-axios';


//引入工具类
import * as validate from './utils/validate';
import utils from './utils/utils';
import apis from './api/main';
import {
    ajax,
    baseURL,
    authorURL
} from './utils/request';


//挂载API和通用公共方法到vue原型
app.config.globalProperties.$api = apis;
app.config.globalProperties.$tools = utils;
app.config.globalProperties.$baseURL = baseURL;
app.config.globalProperties.$validate = validate;
app.config.globalProperties.$bus = bus;
app.config.globalProperties.$currency = currency;

function isContainArr(parent: any, child: any) {
    let flag = false;
    child.forEach((item: any) => {
        if (parent.includes(item)) {
            flag = true;
        }
    });
    return flag;
}


router.beforeEach((to: any, from: any, next: any) => {
    if (to.path === '/login') {
        next();
        return;
    }
    const token = utils.$cookie.getCookie('hxToken');
    if (token) {
        if (to.meta.requireAuth) {
            const authCode = to.meta.permissionCode,
                permissionRouterCode = to.meta.permissionRouterCode,
                authedCodeList = store.state.permission

            if (permissionRouterCode && isContainArr(authedCodeList, permissionRouterCode)) {
                next();
            } else {
                if (authedCodeList.includes(authCode)) {
                    next();
                } else {
                    next({
                        path: '/404'
                    });
                }
            }
        } else {
            next()
        }
    } else {
        window.location.href = window.location.origin + '/login';
    }
});

router.afterEach((to, from) => {
    const { keepAlive, name } = to.meta
    if (keepAlive && name) {
        store.commit('SET_ROUTE_NAMES', name)
    }
    // store.commit('SET_ROUTE_NAMES', name)
})

//按钮权限指令
app.directive('hasAuth', {
    mounted(el, binding) {
        const permissionList = store.state.permission || [];
        if (!permissionList.includes(binding.value)) {
            el.parentNode && el.parentNode.removeChild(el);
        }
    },
});
//按钮权限指令
app.directive('allHasAuth', {
    mounted(el, binding) {
        const arr = binding.value;
        let all_auth = false;
        const permissionList = store.state.permission || [];
        arr.forEach((item: { auth: any; }) => {
            if (permissionList.includes(item.auth)) {
                all_auth = true;
                return;
            }
        });
        if (!all_auth) {
            el.parentNode && el.parentNode.removeChild(el);
        }
    },
});
//提交防重 
app.directive('preventReClick', {
    mounted(el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 3000)
            }
        })
    }
})

VXETable.setup({
    table: {
        stripe: true,
        border: 'none'
    }
})

structure(app)
VXETable.use(VXETablePluginElement)
app.use(VXETable);
app.use(ElementPlus, { locale });
app.use(store);
app.use(router);
app.use(svgPlugin, {
    imports: []
});
app.mount('#app')